import {get, post} from '@/axios';
// 用户注册申请
 export const applyMail = p => post('register/applyMail', p);
// 用户注册信息完善
 export const finishRegister = p => post('register/finishRegister', p);
 // 邮件认证页面获取用户注册信息
export const mailApplyInfo = p => post('register/mailApplyInfo', p);
// 重发邮件
export const resendMail = p => post('register/resendMail', p);
//找回密码
export const sendPwdMail = p => post('findPwd/sendPwdMail', p)

export const config = userId => get('register/config', {userId})



// WEBPACK FOOTER //
// ./src/api/system/register.js